import {$clientApi} from "../http";
import {ICustomerSubscription} from "../models/CustomerSubscription";
import {IInvoice} from "../models/Invoice";

class AccountServiceClass {

    async getSubscriptions(id: number) {
        return $clientApi.get<ICustomerSubscription[]>(`/api/customers/subscriptions/${id}`);
    }

    async getPaymentHistory(id: number) {
        return $clientApi.get<IInvoice[]>(`api/customers/get-client-invoices/${id}`);
    }

}

export const AccountService = new AccountServiceClass();